module.exports = __webpack_public_path__ + "img/hot-wings-1.8902ecc3.jpg";